import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../utils/common'
import Text from '../../../../../Text'
import {
  getMatchCriterionLabelKey,
  getMatchScorePercent,
} from '../../../../RentalPortalMatch'
import { QA_NAME_APPLICANT_FIT_CHECK_BREAKDOWN } from '../ApplicantFitCheckBlock.constants'

import {
  getMatchBreakdownContributionTotal,
  getMatchBreakdownExcludedLabel,
  getMatchBreakdownExcludedWeight,
  getMatchBreakdownWeightTotal,
} from './ApplicantFitCheckBlockBreakdown.utils'

import * as styles from './ApplicantFitCheckBlockBreakdown.module.css'

function ApplicantFitCheckBlockBreakdown({ match }) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_FIT_CHECK_BREAKDOWN })}
      className={styles.ApplicantFitCheckBlockBreakdown}
    >
      <div className={styles.row}>
        <span />
        <Text isSecondary className={styles.columnTitle}>
          {t('RentalPortal.MatchBreakdownColumnWeightKey')}
        </Text>
        <Text isSecondary className={styles.columnTitle}>
          {t('RentalPortal.MatchBreakdownColumnScoreKey')}
        </Text>
        <Text isSecondary className={styles.columnTitle}>
          {t('RentalPortal.MatchBreakdownColumnContributionKey')}
        </Text>
      </div>
      {match.breakdown.map(item => (
        <div className={styles.row} key={item.key}>
          <Text>{t(getMatchCriterionLabelKey(item.key))}</Text>
          <Text className={styles.numeral}>{item.w}</Text>
          <Text className={styles.numeral}>{item.s.toFixed(2)}</Text>
          <Text className={styles.numeral}>{item.ws.toFixed(2)}</Text>
        </div>
      ))}
      {match.breakdown_excluded?.length > 0 ? (
        <div className={styles.row}>
          <Text isSecondary>
            {getMatchBreakdownExcludedLabel({ match, t })}
          </Text>
          <Text isSecondary className={styles.numeral}>
            {getMatchBreakdownExcludedWeight(match)}
          </Text>
          <Text isSecondary className={styles.excluded}>
            {t('RentalPortal.MatchBreakdownExcludedKey')}
          </Text>
        </div>
      ) : null}
      <div className={styles.total}>
        <Text isSecondary>{t('RentalPortal.MatchBreakdownTotalKey')}</Text>
        <Text className={styles.numeral}>
          {getMatchBreakdownWeightTotal(match)}
        </Text>
        <span />
        <Text className={styles.numeral}>
          {getMatchBreakdownContributionTotal(match)}
        </Text>
      </div>
      {match.score_formula ? (
        <Text className={styles.formula}>
          {t('RentalPortal.MatchBreakdownFormulaKey', {
            formula: match.score_formula,
          })}
        </Text>
      ) : null}
      <Text className={styles.footer}>
        {t('RentalPortal.MatchBreakdownFooterKey', {
          coverage: getMatchScorePercent(match.coverage),
        })}
      </Text>
      <Text className={styles.disclaimer}>
        {t('RentalPortal.MatchScoreDisclaimerKey')}
      </Text>
    </div>
  )
}

export default ApplicantFitCheckBlockBreakdown
